import { render, staticRenderFns } from "./editSubsection.vue?vue&type=template&id=c062550c"
import script from "./editSubsection.vue?vue&type=script&lang=js"
export * from "./editSubsection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports